import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState, indicatorState, groupListState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";

function EmployeeDetail({ match }) {
  const [, setIndicator] = useRecoilState(indicatorState);
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const user = useRecoilValue(userState);
  const [employeeInfo, setEmployeeInfo] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [department, setDepartment] = useState("");
  const [status, setStatus] = useState("");
  const [groupId, setGroupId] = useState("");
  const history = useHistory();
  const employeeId = match.params.id;

  useEffect(() => {
    if (parseInt(status) === 100) {
      setStatus(100);
    } else if (parseInt(status) === 200) {
      setStatus(200);
    } else {
      setStatus(300);
    }
  }, [status]);

  useEffect(() => {
    setIndicator("홈 > 직원 관리 > 직원 조회 및 수정");

    const getEmployeeDetail = async () => {
      try {
        const { data } = await awsInstance.get("/business/employee", {
          params: {
            id: employeeId,
          },
        });
        if (data.code === "SUCCESS") {
          const info = data.data[0];
          setEmployeeInfo(info);
          setName(info.name);
          setPhoneNumber(info.phone_number);
          setDepartment(info.department);
          setGroupId(info.business_group_id);
          setStatus(info.status);
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      }
    };

    const getGroupList = async () => {
      try {
        const { data } = await awsInstance.get("/business/group-list", {
          params: {
            id: user.company_id,
          },
        });
        if (data.code === "SUCCESS") {
          setGroupList(data.data);
        }
      } catch (e) {
        alert(e);
      }
    };

    getEmployeeDetail();
    getGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPhoneNumberChange = (e) => {
    if (isFinite(e.target.value)) {
      setPhoneNumber(e.target.value);
    }
  };
  const onSubmitGroup = async (event) => {
    event.preventDefault();
    if (!name) {
      alert("이름을 입력해주세요.");
      return false;
    }
    if (!phoneNumber || phoneNumber.length < 11) {
      alert("휴대폰 번호를 입력해주세요.");
      return false;
    }

    const params = {
      business_user_id: employeeId,
      name: name,
      phone_number: phoneNumber,
      department: department,
      status: status,
      business_group_id: groupId,
    };

    try {
      const { data } = await awsInstance.put(
        `/business/employee`,
        JSON.stringify(params)
      );
      if (data.code === "SUCCESS") {
        alert("성공적으로 수정되었습니다.");
        history.push("/employee");
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    }
  };
  return (
    <div className="employee_modify">
      <h5>직원 조회 및 수정</h5>
      <table className="table table-detail">
        <tbody>
          <tr>
            <th colSpan="1" className="width-20">
              <span>이메일*</span>
            </th>
            <td colSpan="3" className="txt-left pl-2 p-1 py-2">
              <p className="m-0">{employeeInfo.email}</p>
              <span className="txt-gray font-small font-normal text-muted">
                이메일은 수정이 불가합니다.
              </span>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="width-20">
              <span>이름*</span>
            </th>
            <td colSpan="3" className="txt-left txt-dark-gray pt-0 pb-0">
              <input
                type="text"
                className="form-control display-inline-block width-30"
                value={name}
                maxLength="5"
                onChange={(e) => setName(e.target.value)}
                required
              ></input>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="txt-dark-gray background-light width-20">
              <span>휴대폰 번호*</span>
            </th>
            <td colSpan="3" className="txt-left pt-0 pb-0">
              <input
                type="text"
                className="form-control display-inline-block width-30"
                value={phoneNumber}
                maxLength="11"
                onChange={onPhoneNumberChange}
                required
              ></input>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="txt-dark-gray background-light width-20">
              <span>부서명</span>
            </th>
            <td colSpan="3" className="txt-left pt-0 pb-0">
              <input
                type="text"
                className="form-control display-inline-block width-30"
                value={department ? department : ""}
                maxLength="10"
                onChange={(e) => setDepartment(e.target.value)}
              ></input>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="width-20">
              <span>그룹*</span>
            </th>
            <td colSpan="3" className="txt-left pt-0 pb-0">
              <select
                className="form-control display-inline-block width-30"
                value={groupId ? groupId : ""}
                onChange={(e) => setGroupId(e.target.value)}
              >
                <option value="" className="font-bold">
                  선택 안 함
                </option>
                {groupList.map((group) => {
                  return (
                    <option
                      key={group.id}
                      value={group.id}
                      className="font-bold"
                    >
                      {group.name}
                    </option>
                  );
                })}
              </select>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="txt-dark-gray background-light width-20">
              <span>상태*</span>
            </th>
            <td colSpan="3" className="p-2 pl-3">
              {status === 100 ? (
                <span>미가입</span>
              ) : (
                <>
                  <label htmlFor="work" className="mr-5 mb-0">
                    <input
                      type="radio"
                      name="work"
                      id="work"
                      className="mr-1"
                      checked={status === 200 ? true : false}
                      value={200}
                      onChange={(event) => setStatus(event.target.value)}
                    />
                    정상
                  </label>
                  <label htmlFor="leave" className="txt-dark-gray mb-0">
                    <input
                      type="radio"
                      name="leave"
                      id="leave"
                      className="mr-1"
                      checked={status === 300 ? true : false}
                      value={300}
                      onChange={(event) => setStatus(event.target.value)}
                    />
                    휴직
                  </label>
                </>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="display-flex justify-content-center">
        <button className="btn-white-md mr-4" onClick={() => history.goBack()}>
          이전
        </button>
        <button className="btn-blue-md" onClick={onSubmitGroup}>
          수정
        </button>
      </div>
    </div>
  );
}

export default EmployeeDetail;
